import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { getAllDocumentsCategory } from 'reactApp/modules/allDocuments/allDocuments.selectors';
import { AllDocumentsCategoryType } from 'reactApp/modules/allDocuments/allDocuments.types';
import { getPublicSharingInfo } from 'reactApp/modules/public/public.actions';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { getCurrentFolder } from 'reactApp/modules/storage/storage.selectors';
import { usePublicThemeId } from 'reactApp/ui/PublicThemePreview/hooks/usePublicThemeId';
import { ThemePreview } from 'reactApp/ui/PublicThemePreview/ThemePreview/ThemePreview';
import { sendXray } from 'reactApp/utils/ga';

import styles from './ToolbarPublicThemePreview.css';

interface PublicThemePreviewProps {
    publicId: string;
}

function PublicThemePreview({ publicId }: PublicThemePreviewProps) {
    const themeId = usePublicThemeId(publicId);
    return (
        <div className={styles.previewContainer}>
            {themeId ? (
                <>
                    Изменить оформление
                    <ThemePreview themeId={themeId} className={styles.previewInToolbar} />
                </>
            ) : (
                <>
                    Выбрать оформление
                    <div className={styles.promoNew}>новое</div>
                </>
            )}
        </div>
    );
}

function PublicThemeText({ publicId }: PublicThemePreviewProps) {
    const themeId = usePublicThemeId(publicId);
    return <>{themeId ? 'Изменить оформление' : 'Выбрать оформление'}</>;
}

export function ToolbarPublicThemePreview() {
    const dispatch = useDispatch();

    const folder = useSelector(getCurrentFolder);
    const publicId = folder && 'weblink' in folder ? folder.weblink : null;
    useEffect(() => {
        emitAnalyticEvent(AnalyticEventNames.TOOLBAR_ITEM_SHOW_BRAND_PAGE);
        sendXray('toolbar_item-show_brand_page');
        dispatch(getPublicSharingInfo({ public_id: publicId || '' }));
    }, []);
    return publicId ? <PublicThemePreview publicId={publicId} /> : null;
}

export function ToolbarPublicThemeText() {
    const folder = useSelector(getCurrentFolder);
    const publicId = folder && 'weblink' in folder ? folder.weblink : null;
    useEffect(() => {
        emitAnalyticEvent(AnalyticEventNames.TOOLBAR_BRAND_PAGE_SHOW);
        sendXray('toolbar-brand-page-show');
    }, []);
    return publicId ? <PublicThemeText publicId={publicId} /> : null;
}

export const ToolbarRemoveItemText = () => {
    const storage = useSelector(getCurrentStorage);
    const allDocumentsCategory = useSelector(getAllDocumentsCategory);
    const { isIncomingPublic, isAllDocuments } = getStorage(storage);

    const deleteImmediately = (isAllDocuments && allDocumentsCategory === AllDocumentsCategoryType.sharedWithYou) || isIncomingPublic;

    return <>{deleteImmediately ? 'Удалить' : 'Переместить в корзину'}</>;
};
